import { Required, DataValidator, IsArray, IsString } from "@/utils/type-vaildator";
import api from "./api";

export interface GenerateKlingTextToVodRequest {
  agentId: string;
  text: string;
  level?: string;
  model: string;
  duration?: number;
  aspectRatio?: string;
  type: number;
}

class MakeGenerateResponseRaw {
  @Required("taskIds cannot be empty")
  @IsString("taskIds must be a string")
  taskId: string;
}

// 生成可灵视频(文生视频)
export const generateKlingTextToVod = async ({
  agentId,
  text,
  type,
  model,
  duration,
  aspectRatio,
  level,
}: GenerateKlingTextToVodRequest): Promise<string> => {
  const res = await api.post<MakeGenerateResponseRaw>("/sj/kling/txt2vod/create", {
    agent_id: agentId,
    text,
    level,
    model,
    duration,
    aspectRatio,
    type,
  });
  const root = res.data;
  const validated = DataValidator.validateOrThrow(root, MakeGenerateResponseRaw);
  return validated.taskId;
};
